import UserService from '../../common/services/user/user.service';

/* @ngInject */
export default class SocialMediaController {
  public socialMediaList = [
    {
      type: 'facebook',
      onClick: () => {
        this.openFacebook();
      }
    },
    {
      type: 'twitter',
      onClick: () => {
        this.openTwitter();
      }
    },
    {
      type: 'instagram',
      onClick: () => {
        this.openInstagram();
      }
    },
    {
      type: 'youtube',
      onClick: () => {
        this.openYoutube();
      }
    }
  ];
  constructor(
    private $window,
    private config,
    private userService: UserService
  ) {}
  public openFacebook() {
    this.$window.open(
      this.config.facebook[this.userService.getTerritory().toLowerCase()],
      '_blank'
    );
  }

  public openTwitter() {
    this.$window.open(
      this.config.twitter[this.userService.getTerritory().toLowerCase()],
      '_blank'
    );
  }

  public openInstagram() {
    this.$window.open(
      this.config.instagram[this.userService.getTerritory().toLowerCase()],
      '_blank'
    );
  }

  public openYoutube() {
    this.$window.open(
      this.config.youtube[this.userService.getTerritory().toLowerCase()],
      '_blank'
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/social-media/social-media.controller.ts